<!-- @format -->
<template>
    <div class="partnership-widget">
        <div class="widget-header">
            <div class="header-text">
                <h3>Apply to Partnership</h3>
            </div>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <div v-if="isLoading" class="loading-screen">
                <loading-screen-svg />
            </div>

            <div v-else class="inputs-container">
                <marketplace-graphic />
                <div class="input-container">
                    <label>Company</label>
                    <company-search v-model="company" :clientId="clientId" :allowManage="true" />
                </div>
                <app-input v-model="form.name" label="Website" placeholder="Company Website" />
                <app-input
                    v-model="form.description"
                    label="Contact"
                    placeholder="Company Website"
                />
                <app-input
                    v-model="form.description"
                    label="Contact Email"
                    placeholder="Email Address"
                />
            </div>
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="cancel-btn transparent-btn" size="normal" @click="closeWidget">
                    Cancel
                </app-button>
            </div>
            <div class="action-container">
                <app-button class="next-btn"> Apply </app-button>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '@/scripts/event-bus.js';
import { required, requiredIf } from 'vuelidate/lib/validators';

const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const AppButton = () => import('@/components/common/app-button.vue');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
const AppInput = () => import('@/components/common/app-input');
const MarketplaceGraphicSvg = () => import('@/components/svg/marketplace-graphic');
const CompanySearch = () => import('@/components/company/company-search');

export default {
    name: 'partnership-widget',

    components: {
        'widget-close-svg': WidgetCloseSvg,
        'app-button': AppButton,
        'loading-screen-svg': LoadingScreenSvg,
        'app-input': AppInput,
        'marketplace-graphic': MarketplaceGraphicSvg,
        'company-search': CompanySearch,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
            form: {
                name: '',
                description: '',
                inputType: null,
                inputValue: [],
                value: '',
            },

            // inputTypeOptions: [
            //     { id: 1, name: 'Single-line Text', value: 'single-line text' },
            //     { id: 2, name: 'Multi-line Text', value: 'multi-line text' },
            //     { id: 3, name: 'Date Picker', value: 'date picker' },
            //     { id: 4, name: 'Single Checkbox', value: 'single checkbox' },
            //     { id: 5, name: 'Multiple Checkboxes', value: 'multiple checkboxes' },
            //     { id: 6, name: 'Number', value: 'number' },
            //     { id: 7, name: 'URL', value: 'url' },
            // ],
        };
    },

    validations() {
        return {
            form: {
                name: {
                    required,
                },

                description: {
                    required,
                },

                inputType: {
                    required,
                },

                inputValue: {
                    required: requiredIf(() => {
                        return this.fieldInputType === 'Multiple Checkboxes';
                    }),
                },

                value: {
                    required: requiredIf(() => {
                        return this.fieldInputType === 'Single Checkbox';
                    }),
                },
            },
        };
    },

    computed: {
        // widgetType() {
        //     return this.widget.options.type;
        // },

        clientId() {
            return this.widget.options.clientId;
        },

        fieldInputType() {
            return this.form.inputType ? this.form.inputType.name : '';
        },

        // isEditMode() {
        //     return this.widget.customFieldId !== null && this.widget.customFieldId !== undefined;
        // },
    },

    created() {
        // if (this.isEditMode) {
        //     this.getEditCustomField();
        // }
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        // getEditCustomField() {
        //     this.isLoading = true;
        //     const { customFieldId } = this.widget;
        //     this.$api
        //         .get(
        //             `/ms/custom-fields/v1/custom${this.widgetType}Fields/${customFieldId}/${this.clientId}`
        //         )
        //         .then(this.setEditCustomFieldData)
        //         .catch(() => {
        //             this.$helpers.showFailNotification('Failed to get custom field info');
        //         })
        //         .finally(() => {
        //             this.isLoading = false;
        //         });
        // },

        // setEditCustomFieldData({ data }) {
        //     const item = data.data;
        //     this.form = {
        //         ...this.form,
        //         name: item.Name,
        //         description: item.Description,
        //         inputType: this.getInputType(item.InputType),
        //         inputValue: this.getInputValue(item.CustomDataFields),
        //         value: this.getValue(item.CustomDataFields, item.InputType),
        //     };
        // },

        // getInputType(name) {
        //     return this.inputTypeOptions.find((option) => option.name.toLowerCase() === name);
        // },

        // getInputValue(values) {
        //     return values.map((value) => value.Name);
        // },

        // getValue(values, type) {
        //     return type === 'single checkbox' ? values[0].Name : '';
        // },
    },
};
</script>

<style>
.partnership-widget .loading-screen {
    text-align: center;
}

.partnership-widget .inputs-container {
    display: flex;
    flex-direction: column;
    row-gap: 24px;
}

.partnership-widget .inputs-container .input-label {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 7px;
}

.partnership-widget .inputs-container .field-value-input {
    display: flex;
    align-items: flex-end;
    column-gap: 10px;
}

.partnership-widget .field-value-input .app-input {
    flex-grow: 1;
}

.partnership-widget .field-value-input .add-value-btn {
    border-radius: 100%;
    padding: 0;
    width: 40px;
}
.partnership-widget .field-value-input .add-value-btn svg path {
    fill: #ffffff;
}

.partnership-widget .app-input input {
    height: 40px;
}

.partnership-widget .app-dropdown .app-select.v-input > .v-input__control > .v-input__slot {
    min-height: 40px;
}

.partnership-widget .app-dropdown .app-select.v-input .v-input__append-inner {
    margin-top: 8px;
}

.partnership-widget .app-button {
    width: 127px;
}

.partnership-widget .transparent-btn {
    background: transparent;
    color: #877d88;
    border: none;
}

.partnership-widget .transparent-btn:hover {
    background: #e1e0e5;
}

.partnership-widget .cancel-btn {
    background: transparent;
    color: #382153;
    border: 2px solid #cac6cb;
}

.partnership-widget .action-container {
    display: flex;
    column-gap: 13px;
}

.partnership-widget .inputs-container .field-checkboxes-values {
    display: flex;
    column-gap: 6px;
    row-gap: 6px;
    margin-top: 7px;
    flex-wrap: wrap;
}

.partnership-widget .inputs-container .field-checkboxes-values .checkbox-value-chip {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #cac6cb;
    border-radius: 12px;
    height: 24px;
    min-width: 116px;
    font-size: 12px;
}

.partnership-widget .checkbox-value-chip .chip-value {
    display: inline-block;
    margin-left: 14px;
}

.partnership-widget .checkbox-value-chip .app-button {
    position: relative;
    left: 1px;
    background-color: transparent;
    width: 24px;
    height: 24px;
    margin-left: 10px;
    padding: 0;
    border-radius: 50%;
}

.partnership-widget .checkbox-value-chip .app-button svg {
    width: 9px;
    height: 9px;
}

.partnership-widget .checkbox-value-chip .app-button:hover {
    background-color: #f5d5e7;
}
</style>
